/**
 * Version change detection utility.
 *
 * Tracks the server version from X-App-Version response headers. When the
 * server version changes (indicating a new deploy), dispatches a custom
 * "app-version-changed" event so banner components can prompt a reload.
 *
 * Usage: call checkResponseVersion(response) after every fetch call.
 */

let initialVersion: string | null = null
let versionChanged = false

/**
 * Check an API response for version changes. Call after every fetch.
 * Safe to call repeatedly — only dispatches the event once per page load.
 */
export function checkResponseVersion(response: Response): void {
  if (versionChanged) return

  const serverVersion = response.headers.get('X-App-Version')
  if (!serverVersion || serverVersion === 'dev' || serverVersion === 'unknown') return

  if (initialVersion === null) {
    initialVersion = serverVersion
    return
  }

  if (serverVersion !== initialVersion) {
    versionChanged = true
    window.dispatchEvent(
      new CustomEvent('app-version-changed', { detail: serverVersion })
    )
  }
}

/** Reset internal state — for testing only. */
export function _resetVersionState(): void {
  initialVersion = null
  versionChanged = false
}
